export default __webpack_public_path__ + "static/media/up_metric.271bbc7a.svg";